import React from 'react';
import './AboutPage.css';
import Navbar from '../Navbar/Navbar';
import { FaEye, FaBullseye, FaHeart } from 'react-icons/fa';
import { FaWarehouse, FaShippingFast, FaTruckMoving } from 'react-icons/fa';
import img1 from '../../assets/employees-working-warehouse.jpg'; // Adjust the path as necessary
import warehouseImage from '../../assets/warehouse.jpg'
import missionImg from '../../assets/mission.jpg'; // Replace with actual image path
import visionImg from '../../assets/vison.jpg';
import valuesImg from '../../assets/value1.jpg';
import Footer from '../Footer/Footer'; // Import the Footer component
import FAQ from '../FAQ/FAQ';

const AboutPage = () => {
  return (
    <div id="about" className="about-us">
      <Navbar />
      <div className="about-main">
        <div className="first-section">
          <div className="main-top">
            <div className="main-left">
              <img src={img1} className='main-img' alt="" />
            </div>
            <div className="main-right"><h1 className="main-title">About Us</h1>
              <p className="main-description">
                Vedant Enterprises is proud to be recognized as one of the leading logistics service providers in Karnataka. With a strong network and dedicated team, we deliver efficient, reliable, and scalable logistics solutions tailored to meet diverse customer needs.              </p>
              <div className="logistics-highlights">
                <h2 className="highlight-title">Key Highlights</h2>
                <ul className="highlight-list">
                  <li> We are pleased to introduce our self as one of the leading Logistic company in Karnataka.</li>
                  <li> We achieved over ₹20 crores in revenue during the last FY.</li>
                  <li> We operating 15 Plus warehouses in entire Karnataka &amp; Goa.</li>
                  <li> We have 300 plus commercial vehicles which support our vast network.</li>
                  <li> We have 200 plus skilled and efficient staff with more than four years of experience.</li>
                  <li> We are expert in Warehouse Management.</li>
                  <li> We delivered more than 2.5+ Lakhs Shipments in a month.</li>
                  <li> We are expert in first mile pickup, mid mile dilevery &amp; last mile delivery.</li>
                </ul>
              </div>

            </div>
          </div>
          <div className="mission-section">
            <div className="mission-header">
              <h2 className="section-title">Who We Are</h2>
              <div className="divider">
                <span></span><span></span><span></span><span></span>
              </div>
            </div>
            <div className="mv-container">
              {/* Vision Image */}
              <div className="mv-box image-box">
                <img src={visionImg} alt="Vision" />
              </div>

              {/* Vision Text */}
              <div className="mv-box text-box white-box">
                <FaBullseye className="mv-icon" />

                <h2>Our Mission</h2>
                <p>To provide the best quality services to the customer ensuring operational excellence and innovation in logistics solutions.</p>
              </div>

              {/* Values Image */}
              <div className="mv-box image-box">
                <img src={valuesImg} alt="Values" />
              </div>

              {/* Mission Text */}
              <div className="mv-box text-box dark-box">
                <FaEye className="mv-icon" />

                <h2>Our Vision</h2>
                <p>To be the customer's most valued service provider and drive the nation towards renewable energy.</p>

              </div>

              {/* Mission Image */}
              <div className="mv-box image-box">
                <img src={missionImg} alt="Mission" />
              </div>

              {/* Values Text */}
              <div className="mv-box text-box orange-box">
                <FaHeart className="mv-icon" />
                <h2>Our Values</h2>
                <p>We give the highest priority to the quality of the customer's requirements, ensuring reliability, integrity, and transparency.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="why-choose-us">
          <div className="content-left">
            <h4>WHY CHOOSE US</h4>
            <h2>We are the Best Choice for Your Logistics Needs</h2>
            <div className="feature">
              <FaWarehouse className="icon" />
              <div>
                <h3>Vast Infrastructure</h3>
                <p>
                  Operating 10+ strategically located warehouses across Karnataka ensuring smooth and safe storage solutions.
                </p>
              </div>
            </div>
            <div className="feature">
              <FaShippingFast className="icon" />
              <div>
                <h3>On-Time Delivery</h3>
                <p>
                  Fleet of 150+ commercial vehicles supporting first-mile pickup and last-mile delivery with efficiency.
                </p>
              </div>
            </div>
            <div className="feature">
              <FaTruckMoving className="icon" />
              <div>
                <h3>Skilled Workforce</h3>
                <p>
                  Experienced team of 200+ professionals committed to handling shipments and warehouse operations with care.
                </p>
              </div>
            </div>
          </div>

          <div className="content-right">
            <p>
              At Vedant Enterprises, we ensure efficient, reliable, and customer-centric logistics services. Our infrastructure, timely delivery,
              and skilled manpower make us the trusted partner in the logistics industry.
            </p>
            <img src={warehouseImage} alt="Vedant Enterprises Warehouse" />
          </div>
        </div>

      </div>
      <FAQ />
      <Footer />
    </div>
  );
};

export default AboutPage;
